// extracted by mini-css-extract-plugin
module.exports = {"sportbg":"sports_sportbg__OQkyC","sportStyle":"sports_sportStyle__2nl0D","sportnews":"sports_sportnews__3aV6v","underline":"sports_underline__1TTwH"};